import "./app.scss";

import { observer } from "mobx-react-lite";
import { BrowserRouter } from "react-router-dom";

import { Header, LoadingDots, ModalPortal, Offline } from "@client/components";
import { useRootContext } from "@client/context/RootContext";
import initializeI18n from "@client/i18n";
import { LoginPage } from "@client/pages/login-page";
import { StatsDashboard } from "@client/pages/stats-dashboard/stats-dashboard";
import { Router } from "@client/router";

import { ErrorBoundary } from "../error-boundary/error-boundary";
import { PreviousDayPickup } from "../previous-day-pickup/previous-day-pickup";

initializeI18n();

export const App = observer(() => {
	const {
		authStore: { checkedIfLoggedIn, loggedIn, isLoggingIn },
		configStore: { isConfigStoreLoaded },
		layoutStore: { isDashboardActive },
	} = useRootContext();

	let isStandaloneDashboard = false;
	if (window.location.pathname === "/stats-dashboard") {
		isStandaloneDashboard = true;
	}

	return (
		<ErrorBoundary>
			<Offline />

			<ModalPortal />
			{!isStandaloneDashboard && loggedIn && <PreviousDayPickup />}
			{!checkedIfLoggedIn || isLoggingIn || !isConfigStoreLoaded ? (
				<LoadingDots />
			) : !loggedIn ? (
				<LoginPage isApiVendor={isStandaloneDashboard} />
			) : isStandaloneDashboard && isDashboardActive ? (
				<StatsDashboard />
			) : (
				<BrowserRouter>
					{!isStandaloneDashboard && <Header />}
					<div className="app-content">
						<Router />
					</div>
				</BrowserRouter>
			)}
		</ErrorBoundary>
	);
});
